module.exports = __webpack_public_path__ + "static/media/Compare.21bba6d4.svg";